import React from 'react';

import Carousel from 'react-multi-carousel';

import { Player } from 'video-react';
import { AiFillStar } from "react-icons/ai";
import { featureslist } from './FeedbackList';

import 'react-multi-carousel/lib/styles.css';

import {
  StyledClientsFeedback,
  HeadingTitle,
  VideoCarousel,
  CarouselThumnail,
  VideoSection,
  DetailsSection,
  ClientLogo,
  Image,
  ClientLabel,
  Title,
  Ratings,
} from './styled';

const ClientsFeedback = () => {

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3.2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 575 },
      items: 2.5,
    },
    mobile: {
      breakpoint: { max: 575, min: 0 },
      items: 1,
    }
  };

  return (
    
    <StyledClientsFeedback className='hidden'>
      <HeadingTitle>Clients Feedback</HeadingTitle>
      <VideoCarousel>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          itemClass="carousel-item-padding-40-px"
        >
          {
            featureslist.map((list) => (
              <CarouselThumnail key={list.id}>
                <VideoSection>
                  <Player
                    playsInline
                    poster={list.poster}
                    src={list.src}
                  />
                </VideoSection>
                <DetailsSection>
                  <ClientLogo>
                    <Image src={list.img} />
                  </ClientLogo>
                  <ClientLabel>
                    <Title>{list.title}</Title>
                    <Ratings>
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                    </Ratings>
                  </ClientLabel>
                </DetailsSection>
              </CarouselThumnail>
            ))
          }
        </Carousel>
      </VideoCarousel>
    </StyledClientsFeedback>
  )
}

export default ClientsFeedback;